<template>
  <div>
    <!-- 提款上限資訊 -->
    <template v-if="isPC">
      <div class="withdraw-detail-frame">
        <div class="detailList">
          <b class="wDtitle">{{ $t('Bao.withdraw_limit') }}</b>
          <span class="wDamount">{{ withdrawalLimit }}</span>
        </div>
        <div class="detailList">
          <b class="wDtitle">{{ $t('Bao.withdrawal_amount_tip_line_2') }}</b>
          <span class="wDamount">
            <template v-if="isCryptoExchange">{{ currency }} </template>
            {{ amountLimit }}
          </span>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="colu colu-12">
        <div class="withdraw-detail-frame colu colu-12">
          <div class="detailList">
            <b class="wDtitle">{{ $t('Bao.withdraw_limit') }}</b>
            <span class="wDamount">{{ withdrawalLimit }}</span>
          </div>
          <div class="detailList">
            <b class="wDtitle">{{ $t('Bao.withdrawal_amount_tip_line_2') }}</b>
            <span class="wDamount">
              <template v-if="isCryptoExchange">{{ currency }} </template>
              {{ amountLimit }}
            </span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { detectMob } from '@/utils/tool'

export default {
  name: 'WithdrawLimitInfo',
  props: {
    withdrawalLimit: {
      type: [String, Number],
      default: 0
    },
    amountLimit: {
      type: [String, Number],
      default: 0
    },
    isCryptoExchange: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: ''
    }
  },
  computed: {
    isPC() {
      return !detectMob()
    }
  }
}
</script>
